import { Card } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";

export const Balance = () => {
  const { frbStakedBalance, wFlrBalance, userLpBalance } = useBalances();
  return (
    <Card>
      <div className="space-y-4">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
          LP Balance
        </h2>

        <div className="space-y-3">
          <div className="flex items-center justify-between py-2.5 border-b border-border/50">
            <span className="text-sm text-muted-foreground">FRB</span>
            <span className="text-lg sm:text-2xl font-bold text-foreground font-mono min-w-0 truncate">
              {parseFloat(frbStakedBalance).toFixed(2)} <span className="text-primary font-semibold">FRB</span>
            </span>
          </div>
          <div className="flex items-center justify-between py-2.5 border-b border-border/50">
            <span className="text-sm text-muted-foreground">SFLR</span>
            <span className="text-lg sm:text-2xl font-bold text-foreground font-mono min-w-0 truncate">
              {parseFloat(wFlrBalance).toFixed(2)} <span className="text-primary font-semibold">SFLR</span>
            </span>
          </div>
        </div>

        <div className="bg-secondary/30 rounded-xl px-4 py-3 flex items-center justify-between">
          <span className="text-sm text-muted-foreground">Farm Percentage</span>
          <span className="inline-flex items-center bg-primary/10 text-primary font-semibold text-sm px-3 py-1 rounded-lg font-mono">
            {parseFloat(userLpBalance/10000).toFixed(4)}%
          </span>
        </div>
      </div>
    </Card>
  );
};
